'use strict';
var $ = require('jquery');

function init() {
	function getHash(that){
		var $this = $(that);
		var href = $this.attr('xlink\:href') || $this.attr('href');
		return href.split('#')[1];
	}
	function switchTab(event) {
		event.preventDefault();
		var hash = getHash(this);
		var $tabTargets = $('div.tabs').find('a[id]');
		$tabTargets.removeClass('active').filter('[id="'+hash+'"]').addClass('active');

		if (window.innerWidth <= 768) {
			document.documentElement.classList.add('modal--open');
		}
	}
	function closeTab(event) {
		event.preventDefault();
		var $tabTargets = $('div.tabs').find('a[id]');
		$tabTargets.removeClass('active');

		if (window.innerWidth <= 768) {
			document.documentElement.classList.remove('modal--open');
		}
	}

	$('main').on('click', 'a[role="tab"], a[aria-controls]', switchTab);
	$('main').on('click', '.tabs__overlay, .tabs__close', closeTab);
}

module.exports = {
	init : init
};
